import { Mark, mergeAttributes, isMacOS, markInputRule, markPasteRule } from '@tiptap/core';
var inputRegex = /(?:^|\s)((?:~~)((?:[^~]+))(?:~~))$/;
var pasteRegex = /(?:^|\s)((?:~~)((?:[^~]+))(?:~~))/g;
var Strike = Mark.create({
  name: 'strike',
  addOptions: function addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML: function parseHTML() {
    return [{
      tag: 's'
    }, {
      tag: 'del'
    }, {
      tag: 'strike'
    }, {
      style: 'text-decoration',
      consuming: false,
      getAttrs: function getAttrs(style) {
        return style.includes('line-through') ? {} : false;
      }
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    return ['s', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this = this;

    return {
      setStrike: function setStrike() {
        return function (_ref2) {
          var commands = _ref2.commands;
          return commands.setMark(_this.name);
        };
      },
      toggleStrike: function toggleStrike() {
        return function (_ref3) {
          var commands = _ref3.commands;
          return commands.toggleMark(_this.name);
        };
      },
      unsetStrike: function unsetStrike() {
        return function (_ref4) {
          var commands = _ref4.commands;
          return commands.unsetMark(_this.name);
        };
      }
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this2 = this;

    var shortcuts = {};

    if (isMacOS()) {
      shortcuts['Mod-Shift-s'] = function () {
        return _this2.editor.commands.toggleStrike();
      };
    } else {
      shortcuts['Ctrl-Shift-s'] = function () {
        return _this2.editor.commands.toggleStrike();
      };
    }

    return shortcuts;
  },
  addInputRules: function addInputRules() {
    return [markInputRule({
      find: inputRegex,
      type: this.type
    })];
  },
  addPasteRules: function addPasteRules() {
    return [markPasteRule({
      find: pasteRegex,
      type: this.type
    })];
  }
});
export { Strike, Strike as default, inputRegex, pasteRegex };